module.exports = __webpack_public_path__ + "Lato-Bold.cccb897485813c7c2569.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Bold.woff2
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Bold.woff2
// module chunks = styles